import { Component, ElementRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { BackendService } from './../shared/index';
import { CVFormService } from './coverage-form.service';

declare let gtag: Function;

@Component({
  selector: 'pax-coverage-form',
  styles: [require('./coverage-form.component.sass')],
  template: require('./coverage-form.component.html')
})
export class CoverageFormComponent {
  token;
  appEnv;

  constructor(
    private _element: ElementRef,
    private _backend: BackendService,
    private _cv: CVFormService,
    private _router: Router,
  ) {
    this.token = this._element.nativeElement.getAttribute('token') || sessionStorage.getItem('token');
    if (this.token) {
      sessionStorage.setItem('token', this.token);
    }
    this._backend.setToken(this.token);

    this.appEnv = this._element.nativeElement.getAttribute('appEnv') || '';
    if (this.appEnv) {
      this._cv.setAppEnv(this.appEnv);
    }

    window.onbeforeunload = function(e) {
      let dialogText = 'Do you want to leave the site?';
      e.returnValue = dialogText;
    };
  }

  onActivate(e, outlet) {
    window.scrollTo(0, 0);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./resources/themes/pandax/bobtail/app/coverage-form/coverage-form.component.ts